import { createFileRoute } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';
import { useClerk } from '@clerk/clerk-react';
import { useQueryClient } from '@tanstack/react-query';
import { CircleNotchIcon } from '@phosphor-icons/react';
import { useAuthStore } from '@/store';
import { clearTokenCache } from '@/lib/api/client';

export const Route = createFileRoute('/_public/logout')({
  component: LogoutPage,
});

function LogoutPage() {
  const { signOut } = useClerk();
  const { clearAuth } = useAuthStore();
  const queryClient = useQueryClient();
  const hasLoggedOut = useRef(false);

  useEffect(() => {
    if (hasLoggedOut.current) return;
    hasLoggedOut.current = true;

    clearAuth();
    clearTokenCache();
    queryClient.clear();

    void signOut({ redirectUrl: '/login' });
  }, [clearAuth, queryClient, signOut]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-4">
        <CircleNotchIcon className="h-8 w-8 text-primary animate-spin" />
        <p className="text-sm font-medium text-foreground">Signing out...</p>
      </div>
    </div>
  );
}
